import { ApiUrls } from "../types/enums";

export const getBonusRules = async ({
  userToken,
  channelId,
  brandId,
}: RequestHeadersConfig): Promise<GetBonusRulesResponse> => {
  const response = await fetch(ApiUrls.GET_BONUS_RULES, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      token: userToken || "",
      channelid: channelId,
      brandid: brandId,
    },
    body: null,
  });
  return response.json();
};
